import React from "react";

import Container from "../../../../../../../../components/Container";
import TextInput from "../../../../../../../../components/Inputs/InputText";
import SelectInput from "../../../../../../../../components/Inputs/SelectInput";
import TruncatedSelectInput from "../../../../../../../../components/Inputs/SelectInput/TruncatedSelectInput";
import { Checkboxes } from "../../../../../../../../components/Inputs/SelectionOptions/Checkboxes";
import Spacer from "../../../../../../../../components/Spacer";
import Text from "../../../../../../../../components/Text";
import TextWithTooltipInfoIcon from "../../components/TextWithInfoIcon";
// Config
import Config from "./Config";

import { ChartType } from "../../../../store/enums";

import useChartOptions from "../ChartHooks/UseChartOptions/useChartOptions";
import { dataSeriesTooltipText, metricTooltipText } from "../shared/OptionSettings";

export const dataseriesRangeOptions = [
	{ value: "5", label: "5" },
	{ value: "10", label: "10" },
];

// Document: For Histogram Chart, data series is summarizedByAxis and should be fit into y axis
// Metric row is anyAxis and should be fit into x axis
const HistogramChartOptions = () => {
	const {
		setDataSeries,
		setXAxisColumnData,
		setChartMetadata,
		visualizeOption,
		dataSeriesOptions,
		anyAxisOptions,
		previousVisualizeOption,
	} = useChartOptions(ChartType.HistogramChart);

	const handleDisplayBellCurve = (change) => {
		if (change.length === 0) {
			setChartMetadata("showBellCurve", false);
		} else {
			setChartMetadata("showBellCurve", true);
		}
	};

	const bellCurveCheckboxValue = [{ value: "showBellCurve", label: "Display Bell Curve Line" }];
	const showBellCurveValue =
		visualizeOption?.showBellCurve === undefined
			? bellCurveCheckboxValue
			: visualizeOption?.showBellCurve
				? bellCurveCheckboxValue
				: []; // default to be selected

	return (
		<>
			<Container marginBottom={2}>
				<Checkboxes
					value={showBellCurveValue}
					options={bellCurveCheckboxValue}
					onChange={handleDisplayBellCurve}
				/>
			</Container>
			<SelectInput
				label="Data Series"
				labelProps={{ color: "neutral-9", weight: "semi-bold", size: "paragraph-3" }}
				results={dataSeriesOptions}
				value={visualizeOption?.dataSeries?.column}
				menuPortalTarget={document.body}
				menuPosition="fixed"
				onChange={(option) => setDataSeries("column", option.value)}
				info={{
					title: "Data Series",
					message: dataSeriesTooltipText,
					titleBottomLine: true,
				}}
			/>
			<Container marginTop="3px" column>
				<TextWithTooltipInfoIcon text="Metric" tooltipMessage={metricTooltipText} />
				<Spacer height={1} />
				<TruncatedSelectInput
					value={
						visualizeOption?.xAxis?.column ||
						previousVisualizeOption?.xAxis?.column ||
						previousVisualizeOption?.yAxis?.column
					}
					results={anyAxisOptions}
					onChange={(option) => setXAxisColumnData("column", option.value)}
				/>
			</Container>
			<Container marginTop="3px">
				<Container centerVertical marginBottom="5px" width={79}>
					<Text size="caption" color="neutral-9" weight="regular">
						# of bins
					</Text>
				</Container>
				<Container block>
					<SelectInput
						value={visualizeOption?.binNum || Config.default_number_of_bins}
						results={dataseriesRangeOptions}
						onChange={(option) => setChartMetadata("binNum", option.value)}
					/>
				</Container>
			</Container>
			<Container marginTop="3px" marginBottom={1}>
				<Container centerVertical width={79}>
					<Text size="caption" color="neutral-9" weight="regular">
						Set Minimum
					</Text>
				</Container>
				<Container block>
					<TextInput
						type="number"
						value={visualizeOption?.xAxis?.min ?? 0}
						onChange={(value) => setXAxisColumnData("min", value)}
						ariaLabel="Set Minimum"
					/>
				</Container>
			</Container>
			<Container marginTop={1} marginBottom={1}>
				<Container centerVertical width={79}>
					<Text size="caption" color="neutral-9" weight="regular">
						Set Maximum
					</Text>
				</Container>
				<Container block>
					<TextInput
						type="number"
						value={visualizeOption?.xAxis?.max ?? 100}
						onChange={(value) => setXAxisColumnData("max", value)}
						ariaLabel="Set Maximum"
					/>
				</Container>
			</Container>
		</>
	);
};

export default HistogramChartOptions;
